"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import Cookies from "js-cookie";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import RenderImage from "../atoms/RenderImage";
import { useIsMobile } from "@/hooks/use-mobile";
import { ROUTE_PATHS } from "@/constants/routes";
import { useRouter } from "next/navigation";
import { useTranslations } from "next-intl";
import { ModalTypeEnum, useModal } from "./modal-provider/ModalProvider";
import { Badge } from "../ui/badge";
const PREFERENCES_COOKIE_OPTIONS = {
  expires: 60,
  // 60 days
  path: "/"
  // secure: true, // enable in production if needed
  // sameSite: "strict",
};
type CookiePreferences = {
  [key: string]: boolean;
};
const COOKIE_TYPES = [{
  id: "necessary",
  key: "necessary",
  required: true
}, {
  id: "performance",
  key: "performance"
}, {
  id: "targeted",
  key: "targeted"
}, {
  id: "functionality",
  key: "functionality"
}, {
  id: "others",
  key: "others"
}];
function CookieContent() {
  const $ = _c(68);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {};
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [preferences, setPreferences] = useState(t0);
  const [showMore, setShowMore] = useState(false);
  const {
    closeModal
  } = useModal();
  useRouter();
  const tCookies = useTranslations("components.cookies");
  useIsMobile();
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const storedPreferencesStr = Cookies.get("cookiePreferences");
      const storedPreferences = storedPreferencesStr ? JSON.parse(storedPreferencesStr) : {};
      setPreferences(storedPreferences);
    };
    t2 = [];
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== preferences) {
    t3 = (key, value) => {
      const updatedPreferences = {
        ...preferences,
        [key]: value
      };
      setPreferences(updatedPreferences);
      Cookies.set("cookiePreferences", JSON.stringify(updatedPreferences), PREFERENCES_COOKIE_OPTIONS);
    };
    $[3] = preferences;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const setPreference = t3;
  let t4;
  if ($[5] !== closeModal || $[6] !== preferences) {
    t4 = () => {
      Cookies.set("cookiePreferences", JSON.stringify(preferences), PREFERENCES_COOKIE_OPTIONS);
      Cookies.set("cookiesAccepted", "true", PREFERENCES_COOKIE_OPTIONS);
      closeModal();
    };
    $[5] = closeModal;
    $[6] = preferences;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const savePreferences = t4;
  let t5;
  if ($[8] !== closeModal) {
    t5 = () => {
      const allAccepted = COOKIE_TYPES.reduce(_temp, {} as CookiePreferences);
      Cookies.set("cookiePreferences", JSON.stringify(allAccepted), PREFERENCES_COOKIE_OPTIONS);
      Cookies.set("cookiesAccepted", "true", PREFERENCES_COOKIE_OPTIONS);
      closeModal();
    };
    $[8] = closeModal;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const acceptAll = t5;
  let t6;
  if ($[10] !== closeModal) {
    t6 = () => {
      const onlyNecessary = COOKIE_TYPES.reduce(_temp2, {} as CookiePreferences);
      Cookies.set("cookiePreferences", JSON.stringify(onlyNecessary), PREFERENCES_COOKIE_OPTIONS);
      Cookies.set("cookiesAccepted", "false", PREFERENCES_COOKIE_OPTIONS);
      closeModal();
    };
    $[10] = closeModal;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const rejectAll = t6;
  let t7;
  if ($[12] !== tCookies) {
    t7 = tCookies("title");
    $[12] = tCookies;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t7) {
    t8 = <p className="text-zinc-900 text-xl font-bold">{t7}</p>;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== tCookies) {
    t9 = tCookies("description");
    $[16] = tCookies;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t9) {
    t10 = <p className="text-zinc-600 text-sm mt-1">{t9}{" "}</p>;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t8) {
    t11 = <div>{t8}{t10}</div>;
    $[20] = t10;
    $[21] = t8;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="relative sm:pr-12"><div className="w-14 sm:w-16 h-14 sm:h-16"><RenderImage src="/assets/cookie.svg" alt={"Imagens de im\xF3veis"} className="object-contain h-full w-full" data-sentry-element="RenderImage" data-sentry-source-file="cookiePopup.tsx" /></div></div>;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t11) {
    t13 = <div className="flex justify-between items-center w-full">{t11}{t12}</div>;
    $[24] = t11;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== tCookies) {
    t14 = tCookies("detailedDescription1");
    $[26] = tCookies;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t14) {
    t15 = <p className="mt-6">{t14}</p>;
    $[28] = t14;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== showMore || $[31] !== tCookies) {
    t16 = !showMore && <p className="text-blue-600 cursor-pointer hover:text-blue-700 underline text-sm mt-3 font-medium transition-colors" onClick={() => setShowMore(true)}>{tCookies("showMore")}</p>;
    $[30] = showMore;
    $[31] = tCookies;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== showMore || $[34] !== tCookies) {
    t17 = showMore && <><p className="mt-4">{tCookies("detailedDescription2")}</p><p className="mt-4">{tCookies("detailedDescription3")}</p></>;
    $[33] = showMore;
    $[34] = tCookies;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t15 || $[37] !== t16 || $[38] !== t17) {
    t18 = <div className="text-zinc-700 text-sm leading-relaxed">{t15}{t16}{t17}</div>;
    $[36] = t15;
    $[37] = t16;
    $[38] = t17;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== t13 || $[41] !== t18) {
    t19 = <div>{t13}{t18}</div>;
    $[40] = t13;
    $[41] = t18;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] !== preferences || $[44] !== setPreference || $[45] !== tCookies) {
    t20 = COOKIE_TYPES.map(t21 => {
      const {
        id,
        key: key_0,
        required
      } = t21;
      return <div key={id} className=" flex items-start space-x-3 cursor-pointer relative  rounded-lg hover:bg-zinc-50 transition-colors">{required && <Badge className="absolute top-0 right-2 bg-green-600 hover:bg-green-600 text-white text-xs">{tCookies("alwaysActive")}</Badge>}<Checkbox id={id} checked={required || preferences[id] || false} onCheckedChange={value_0 => !required && setPreference(id, Boolean(value_0))} disabled={required} className={`${required ? "opacity-50 cursor-not-allowed" : ""} mt-0.5`} /><div className="flex-1"><label htmlFor={id} className="cursor-pointer text-sm font-medium text-zinc-800 leading-normal peer-disabled:cursor-not-allowed peer-disabled:opacity-70">{tCookies(key_0)}</label><p className="text-xs text-zinc-500 mt-1">{tCookies(`${key_0}Description`)}</p></div></div>;
    });
    $[43] = preferences;
    $[44] = setPreference;
    $[45] = tCookies;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  let t21;
  if ($[47] !== t20) {
    t21 = <div className="flex flex-col space-y-5 my-8">{t20}</div>;
    $[47] = t20;
    $[48] = t21;
  } else {
    t21 = $[48];
  }
  let t22;
  if ($[49] !== t19 || $[50] !== t21) {
    t22 = <div className=" p-6 bg-gray-50 pb-4 -mt-2 sm:-mt-6 pt-10 overflow-auto">{t19}{t21}</div>;
    $[49] = t19;
    $[50] = t21;
    $[51] = t22;
  } else {
    t22 = $[51];
  }
  let t23;
  if ($[52] !== tCookies) {
    t23 = tCookies("rejectAll");
    $[52] = tCookies;
    $[53] = t23;
  } else {
    t23 = $[53];
  }
  let t24;
  if ($[54] !== rejectAll || $[55] !== t23) {
    t24 = <Button data-testid="reject-cookies" onClick={rejectAll} className="w-full text-zinc-700 hover:text-zinc-900 hover:bg-zinc-100" variant="ghost" size="md" data-sentry-element="Button" data-sentry-source-file="cookiePopup.tsx">{t23}</Button>;
    $[54] = rejectAll;
    $[55] = t23;
    $[56] = t24;
  } else {
    t24 = $[56];
  }
  let t25;
  if ($[57] !== acceptAll || $[58] !== preferences || $[59] !== savePreferences || $[60] !== tCookies) {
    t25 = Object.keys(preferences).some(key_1 => preferences[key_1] && key_1 !== "necessary") ? <Button data-testid="save-cookies" onClick={savePreferences} className="w-full" variant="simpleDark" size="md">{tCookies("saveAndClose")}</Button> : <Button data-testid="accept-cookies" onClick={acceptAll} className="w-full" variant="simpleDark" size="md">{tCookies("acceptAll")}</Button>;
    $[57] = acceptAll;
    $[58] = preferences;
    $[59] = savePreferences;
    $[60] = tCookies;
    $[61] = t25;
  } else {
    t25 = $[61];
  }
  let t26;
  if ($[62] !== t24 || $[63] !== t25) {
    t26 = <div className="flex gap-3 w-full p-4 px-6  bg-white shadow-2xl">{t24}{t25}</div>;
    $[62] = t24;
    $[63] = t25;
    $[64] = t26;
  } else {
    t26 = $[64];
  }
  let t27;
  if ($[65] !== t22 || $[66] !== t26) {
    t27 = <div className="flex flex-col overflow-hidden shadow-lg md:rounded-lg justify-between w-full sm:bg-gray-100" data-sentry-component="CookieContent" data-sentry-source-file="cookiePopup.tsx">{t22}{t26}</div>;
    $[65] = t22;
    $[66] = t26;
    $[67] = t27;
  } else {
    t27 = $[67];
  }
  return t27;
}
function _temp2(acc_0, option_0) {
  acc_0[option_0.id] = !!option_0.required;
  return acc_0;
}
function _temp(acc, option) {
  acc[option.id] = true;
  return acc;
}
function CookieBanner(t0) {
  const $ = _c(33);
  const {
    onAccept,
    onManagePreferences
  } = t0;
  const tCookies = useTranslations("components.cookies");
  const router = useRouter();
  let t1;
  if ($[0] !== tCookies) {
    t1 = tCookies("title");
    $[0] = tCookies;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <h2 className="text-md sm:text-lg font-semibold text-zinc-700">{t1}</h2>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== tCookies) {
    t3 = tCookies("bannerMessage");
    $[4] = tCookies;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== router) {
    t4 = () => router.push(ROUTE_PATHS.PRIVACY_POLICY);
    $[6] = router;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== tCookies) {
    t5 = tCookies("learnMore");
    $[8] = tCookies;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <button onClick={t4} className="text-xs sm:text-sm text-zinc-900 hover:text-zinc-700 underline font-medium cursor-pointer">{t5}</button>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t3 || $[14] !== t6) {
    t7 = <p className="text-sm text-zinc-600 leading-relaxed">{t3}{" "}{t6}</p>;
    $[13] = t3;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== tCookies) {
    t8 = tCookies("acceptAll");
    $[16] = tCookies;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== onAccept || $[19] !== t8) {
    t9 = <Button data-testid="accept-cookies" onClick={onAccept} variant="simpleDark" size="md" className=" w-full" data-sentry-element="Button" data-sentry-source-file="cookiePopup.tsx">{t8}</Button>;
    $[18] = onAccept;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== tCookies) {
    t10 = tCookies("managePreferences");
    $[21] = tCookies;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== onManagePreferences || $[24] !== t10) {
    t11 = <Button onClick={onManagePreferences} variant="outline" size="md" className="w-full" data-sentry-element="Button" data-sentry-source-file="cookiePopup.tsx">{t10}</Button>;
    $[23] = onManagePreferences;
    $[24] = t10;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t11 || $[27] !== t9) {
    t12 = <div className="flex flex-col sm:flex-row gap-3 mt-2">{t9}{t11}</div>;
    $[26] = t11;
    $[27] = t9;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t12 || $[30] !== t2 || $[31] !== t7) {
    t13 = <div className="p-6 sm:p-8 mx-auto" data-sentry-component="CookieBanner" data-sentry-source-file="cookiePopup.tsx"><div className="flex flex-col gap-4 ">{t2}{t7}{t12}</div></div>;
    $[29] = t12;
    $[30] = t2;
    $[31] = t7;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  return t13;
}
export function CookiePopup() {
  const $ = _c(10);
  const [showCookiePrompt, setShowCookiePrompt] = useState(false);
  const {
    openModal
  } = useModal();
  const isMobile = useIsMobile();
  const [mounted, setMounted] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const cookiesAcceptedStr = Cookies.get("cookiesAccepted");
      const accepted = cookiesAcceptedStr === "true" ? true : cookiesAcceptedStr === "false" ? false : null;
      setShowCookiePrompt(accepted === null);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setMounted(true);
    };
    t3 = [];
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      const allAccepted = COOKIE_TYPES.reduce(_temp3, {} as CookiePreferences);
      Cookies.set("cookiePreferences", JSON.stringify(allAccepted), PREFERENCES_COOKIE_OPTIONS);
      Cookies.set("cookiesAccepted", "true", PREFERENCES_COOKIE_OPTIONS);
      setShowCookiePrompt(false);
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const acceptAll = t4;
  let t5;
  if ($[5] !== isMobile || $[6] !== openModal) {
    t5 = () => {
      setShowCookiePrompt(false);
      if (isMobile) {
        openModal(ModalTypeEnum.GENERIC_DRAWER, {
          children: <CookieContent />,
          draggerClassName: "bg-zinc-300",
          className: "bg-gray-50",
          onClose: _temp4
        });
      } else {
        openModal(ModalTypeEnum.GENERIC_DIALOG, {
          children: <CookieContent />,
          className: "w-2xl bg-gray-100",
          childrenClassName: "!p-0",
          onClose: _temp5
        });
      }
    };
    $[5] = isMobile;
    $[6] = openModal;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const openPreferences = t5;
  if (!showCookiePrompt || !mounted) {
    return null;
  }
  let t6;
  if ($[8] !== openPreferences) {
    t6 = createPortal(<div className="fixed inset-x-0 z-50 bottom-10 px-4 sm:px-0"><div className="w-full sm:max-w-2xl sm:mx-auto bg-white shadow-app-2xl rounded-xl"><CookieBanner onAccept={acceptAll} onManagePreferences={openPreferences} /></div></div>, document.body);
    $[8] = openPreferences;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}
function _temp5() {}
function _temp4() {}
function _temp3(acc, option) {
  acc[option.id] = true;
  return acc;
}